import { useCallback, useEffect, useState, useRef } from 'react';
import { getFilteredProducts } from '@yme/api';
import { buildRequestParamForAuthor } from './helpers';
export const useProductsBeforeEmbargoRelease = ({ categoryIds, productEndpoint, productType, }) => {
    const [productsBeforeEmbargoRelease, setProductsBeforeEmbargoRelease] = useState([]);
    const cacheRef = useRef({});
    const getProductsBeforeEmbargoRelease = useCallback(async () => {
        const params = buildRequestParamForAuthor({
            categoryIds,
            productType,
        });
        if (params) {
            const cacheKey = `${JSON.stringify(categoryIds)}-${productEndpoint}-${productType}`;
            if (cacheRef.current[cacheKey]) {
                setProductsBeforeEmbargoRelease(cacheRef.current[cacheKey]);
                return;
            }
            const response = await getFilteredProducts({
                endpoint: productEndpoint,
                config: {
                    ...params,
                    productType,
                },
            });
            if (response) {
                cacheRef.current[cacheKey] = response.results;
                setProductsBeforeEmbargoRelease(response.results);
            }
        }
    }, [categoryIds, productEndpoint, productType]);
    useEffect(() => {
        if (categoryIds && categoryIds.length > 0 && productEndpoint && productType) {
            getProductsBeforeEmbargoRelease();
        }
    }, [categoryIds, getProductsBeforeEmbargoRelease, productEndpoint, productType]);
    return {
        productsBeforeEmbargoRelease,
    };
};
